import { jsx as _jsx } from "react/jsx-runtime";
import { hydrateRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import { getJSONFromScriptTag } from '@phishtool/ui';
import Router from './router';
import Providers from './providers';
import './assets';
loadableReady(() => {
    const MOUNT_POINT = document.getElementById('app');
    const state = getJSONFromScriptTag('preloaded-state');
    hydrateRoot(MOUNT_POINT, _jsx(Providers, Object.assign({}, state, { children: _jsx(Router, {}) })));
});
